import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-catalogs',
  templateUrl: './catalogs-catalogs.component.html',
  styleUrls: ['./catalogs-catalogs.component.scss']
})
export class CatalogsCatalogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
